import { CoursesPage } from "@/components/courses/CoursesPage";

export function CoursesRoute() {
  return <CoursesPage />;
}
